module.exports = __webpack_public_path__ + "static/media/ico-ofertas-002.7da290cf.svg";